// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"64e4978e","133":"97fda956","205":"3cba7ebf","210":"4cf9bda1","611":"3cba7ebf","663":"f80a77b7","665":"426ae6bb","727":"29225d61","763":"1f6a99f1"}[chunkId] + ".chunk.css";
};